import React, { useEffect, useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import { Typography } from "@material-ui/core";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import DB_Status from "../../model/enum/status.class";
import ServiceModal from "./ServiceModal";
import ServiceModel from "../../model/service";
import useStyles from "./styles";
import { useSearchParams } from "react-router-dom";
import { PrimaryColor } from "../../shared/styles/colors";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35rem",
  bgcolor: "background.paper",
  order: "none",
  borderRadius: "8px",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  maxHeight: "90vh", // Restrict maximum height to 80% of the viewport height
  overflowY: "auto", // Enable vertical scrolling
  "@media (max-width: 640px)": {
    width: "80%",
  },
};

interface Props {
  service: ServiceModel;
  resetList?: () => void;
  onOpen?: (id?: string) => void;
  onClose?: () => void;
}

const ServiceDetailModal = ({ service, resetList, onOpen, onClose }: Props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const handleOpen = () => {
    setOpen(true);
    if (onOpen) {
      onOpen(service.id?.toString());
    }
  };

  const handleClose = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  useEffect(() => {
    const serviceId = searchParams.get("serviceId");
    if (!open && serviceId && serviceId === service.id?.toString()) {
      handleOpen();
    }
  }, [searchParams]);

  return (
    <div>
      <Button onClick={handleOpen}>
        <MoreVertIcon sx={{ color: PrimaryColor}}/>
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflowY: "auto" }}
      >
        <Box sx={style}>
          <div className={classes.headerDiv}>
            <Typography className={classes.title}>
              <div
                style={DB_Status.mapStatusDivColor(
                  service.available ? DB_Status.ACTIVE : DB_Status.INACTIVE
                )}
              >
                <div
                  style={DB_Status.mapStatusRoundedColor(
                    service.available ? DB_Status.ACTIVE : DB_Status.INACTIVE,
                    false
                  )}
                ></div>
              </div>
            </Typography>
            <div className={classes.headerSubDiv}>
              <ServiceModal service={service} resetList={resetList} />
              <Button onClick={handleClose} sx={{ color: "black" }}>
                <CloseIcon />
              </Button>
            </div>
          </div>
          <hr />
          <div className={classes.form}>
            <Typography className={classes.label}>Name</Typography>
            <Typography className={classes.inputDetail}>
              {service.name}
            </Typography>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default ServiceDetailModal;
